import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import DatePicker from 'react-datepicker';
import {getMonth, getYear} from 'date-fns';
import en from 'date-fns/locale/en-US';
import me from 'date-fns/locale/sr-Latn';
import {ReactComponent as ChevronLeft} from './img/chevron-left.svg';
import {ReactComponent as ChevronRight} from './img/chevron-right.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';
import Calendar from './img/calendar.svg';
import {getLanguage} from 'react-switch-lang';

const InputDate = ({
  name,
  defaultValue,
  className = 'form-control',
  minDate,
  maxDate,
  isClearable=false,
    forceSelected,
  ...rest
}) => {
  const {control, errors, watch} = useFormContext();
  const selected = watch(name);
  const months = [];

  const lang = getLanguage();

  for (let i = 0; i < 12; i++) {
    months.push(
      lang === 'eng'
        ? en.localize.month(i).toUpperCase()
        : me.localize.month(i).toUpperCase()
    );
  }

  const renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    return (
      <div className="datepicker-custom-header">
        <button type="button" onClick={() => decreaseMonth()}>
          <ChevronLeft />
        </button>
        <div className="month">
          {months[getMonth(date)]} {getYear(date)}
        </div>
        <button type="button" onClick={() => increaseMonth()}>
          <ChevronRight />
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="wrapper-calendar">
      <img className={`calendar-img-aps `} src={Calendar} alt="Calendar" />
        <Controller
          defaultValue={defaultValue ? new Date(defaultValue) : null}
          className={`${className} ${errors[name] && 'error-field'}`}
          as={DatePicker}
          name={name}
          control={control}
          minDate={minDate}
          // selected={selected}
          selected={
              forceSelected
                  ? selected || (defaultValue ? defaultValue : null) // Ova logika radi samo kad je forceSelected aktivan
                  : selected
          }
          maxDate={maxDate}
          autoComplete={'off'}
          placeholderText={'_ _ _'}
          dateFormat="dd.MM.yyyy."
          showYearDropdown={true}
          isClearable={isClearable}
          renderCustomHeader={renderCustomHeader}
          locale={lang === 'eng' ? en : me}
          {...rest}
        />
      </div>

      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default InputDate;
